import AnnualReportForm from "../../../model/AnnualReportForm";

const RESEARCH_DONE_IN_LAST_12_MONTHS = `Please describe the research you have undertaken in the last 12 months.`;
const UPDATE_TO_SCOPE_OF_PROJECT = `Please provide an up-to-date summary of the scope of your research project.`;
const TEXT_WILL_BE_PUBLISHED = `The text from this section will be published on the UK Biobank website to inform other 
      researchers, participants, and the general public of the work being undertaken using the resource. Please write 
      this section so that it's easy for everyone to understand, even if they’re not familiar with the technical 
      details or background.`;

/**
 * Props for this component
 */
interface LastYearResearchQuestionProps {
   form: AnnualReportForm,
   isLocked: boolean,
}

/**
 * Group of questions related to the research done over the previous 12 months.
 *
 * Used in: {@link ApplicantAnnualReportForm|Applicant annual report}
 *
 * @param form An {@link AnnualReportForm} object with a saved report (Could be empty if it's a new report)
 * @param isLocked A boolean to indicate if the report is locked for editing or not
 */
export default function LastYearResearchQuestion({form, isLocked}: LastYearResearchQuestionProps) {
   return (
      <div id="lastYearRes" className="annual-report-question">
         <label id="lastYearResMainText" className="question-text">{RESEARCH_DONE_IN_LAST_12_MONTHS}</label>
         <textarea id="lastYearResInput" name="lastYearResInput" className="form-control" rows={3}
                   disabled={isLocked}
                   onChange={(e) => form.researchActivity = encodeURIComponent(e.target.value)}
                   required minLength={100} maxLength={1000}>
         {decodeURIComponent(form.researchActivity ? form.researchActivity : '')}</textarea>
         <div id="lastYearResFeedback" className="invalid-feedback">
            Your answer must have between 100 and 1000 characters.
         </div>
         <label id="lastYearResScopeMainText" className="question-text">{UPDATE_TO_SCOPE_OF_PROJECT}</label>
         <textarea id="lastYearResScopeInput" name="lastYearResInput" className="form-control" rows={3}
                   disabled={isLocked}
                   onChange={(e) => form.currentResearchSummary = encodeURIComponent(e.target.value)}
                   required minLength={100} maxLength={1000}>
         {decodeURIComponent(form.currentResearchSummary ? form.currentResearchSummary : '')}</textarea>
         <div id="lastYearResScopeFeedback" className="invalid-feedback">
            Your answer must have between 100 and 1000 characters.
         </div>
         <span id="lastYearResExtraInfo" className="extra-info">{TEXT_WILL_BE_PUBLISHED}</span>
      </div>
   );
}
